// @ts-nocheck
import { EmployerPlanPricing } from "."
import { Network } from "../../.."
import store from "../../../../store"
import { formatDate, getCurrency } from "../../../formating"
import APIWrapper from "../../APIWrapper"

export class EmployerPlanAttributes extends APIWrapper {

}

export class EmployerPlan extends EmployerPlanAttributes {
	static mapByTypeWithCount(plans) {
		const map = new Map()
		const count = {}

		for (const plan of plans.map((plan) => new this(plan))) {
			if (count[plan.type] === undefined) count[plan.type] = 0
			count[plan.type]++

			const key = `${plan.type}-${count[plan.type]}`

			map.set(key, plan)
		}

		return map
	}

	get fieldType() {
		return this.longType
	}

	get dates() {
		return {
			start: new Date(this.startDate),
			end: new Date(this.endDate)
		}
	}

	get startYear() {
		return formatDate({
			data: this.startDate,
			actions: ["new-date-object"],
			options: ["append-timezone"]
			//@ts-ignore
		})?.getFullYear()
	}

	get label() {
		return this.type
	}

	get accessor() {
		return this.type
	}

	get tableValues() {
		const plan = this
		const {
			name,
			type,
			startDate,
			endDate,
			gracePeriodDays,
			terminationRunoutDays,
			codes,
			qualifiedMedicalExpenses,
			medicalPremiums,
			dentalPremiums,
			visionPremiums,
			yearEndRunoutDays,
			contributions
		} = plan
		let expenses = ""
		const qualifiedMedicalExpensesArr= []

		if (medicalPremiums) qualifiedMedicalExpensesArr.push(`Healthcare`)
		if (dentalPremiums) qualifiedMedicalExpensesArr.push(`Dental / Vision`)
		if (qualifiedMedicalExpenses) qualifiedMedicalExpensesArr.push(`Qualified Medical`)

		if (qualifiedMedicalExpensesArr.length > 0) expenses += qualifiedMedicalExpensesArr.join(", ")

		let displayAnnualContributions = ""
		if (contributions?.family || contributions?.single)
			displayAnnualContributions = `${getCurrency({
				amount: contributions.single,
				actions: ["divide"]
			})} / ${getCurrency({
				amount: contributions.family,
				actions: ["divide"]
			})}`
		else if (contributions?.fixed)
			displayAnnualContributions = `${getCurrency({
				amount: contributions.fixed,
				actions: ["divide"]
			})}`

		let displayEmployerContributions =
			contributions?.single ||
				contributions?.family ||
				contributions?.match ||
				contributions?.matchMinimum ||
				contributions?.fixed ||
				type?.includes("HRA")
				? "Yes"
				: "No"

		return {
			plan: type,
			name: name,
			number: this.planNumber,
			startDate: formatDate({
				data: startDate,
				actions: ["display"],
				options: ["append-timezone"],
				defaultReturn: ""
			}),
			employerContributions: displayEmployerContributions,
			annualContributions: displayAnnualContributions,
			endDate: formatDate({
				data: endDate,
				actions: ["display"],
				options: ["append-timezone"],
				defaultReturn: ""
			}),
			gracePeriodDays: typeof gracePeriodDays === "number" ? gracePeriodDays : "",
			termination: typeof terminationRunoutDays === "number" ? terminationRunoutDays : "",
			runout: typeof yearEndRunoutDays === "number" ? yearEndRunoutDays : "",
			// employerContributionCode: this.codes.employerContributionCode,
			// deduction: this.codes.preTaxDeductionCode,
			// reimbursement: this.codes.nonTaxableReimbursementCode,
			contributionTiming: contributions?.timing?.event
				? contributions?.timing?.event === "dayOfMonth"
					? "Monthly"
					: "Upfront"
				: "",

			match: contributions?.match
				? `${contributions?.minimumMatch
					? getCurrency({
						amount: contributions?.minimumMatch,
						actions: ["divide"],
						defaultReturn: ""
					}) + " / "
					: ""
				}${getCurrency({
					amount: contributions?.match,
					actions: ["divide"],
					defaultReturn: ""
				})}`
				: "",
			expenses
		}
	}

	get planStatus() {
		if (this?.closedTs) return "Closed"
		if (this?.completedTs) return "Complete"
		else return "Incomplete"
	}

	async setPricingConfig({ data }) {
		try {
			if (this.links?.setPricingConfig?.url) {
				const { data: employerPlanPricingData } = await Network.AxiosWrapperV2.send({
					...this.links.setPricingConfig,
					data
				})

				await store.setNotification("notification", true, {
					msg: `Successfully created ${this.type} pricing.`,
					severity: "success",
					isPersist: true
				})
				return new EmployerPlanPricing(employerPlanPricingData)
			}
		} catch (err) {
			console.error(err)
		}
	}
}
